import { PageRating } from './PageRating';

export const SecondarySidebarAddon = () => <PageRating />;
